import { POC_LISTING, UPDATE_POC_STATUS } from "./type";

const initalState = {
  pocList: {},
  updateStatus: "",
};

const baPocListReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case POC_LISTING:
      return {
        ...state,
        pocList: payload,
      };

    case UPDATE_POC_STATUS:
      return {
        ...state,
        updateStatus: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default baPocListReducer;
